import { useQuery } from '@tanstack/react-query';
import { getCenterFeatureFlagsAPI } from '../api/center';
import { getItemWithExpiration } from '../lib/utils';
// 플래그 정규화만 필요한 공용 훅에서 API barrel을 불러오면 Jest/구형 번들이
// ESM-only ky까지 즉시 평가한다. 순수 타입 모듈을 직접 참조해 기존 화면 계약을 유지한다.
import { normalizeSharedMembershipFeatureFlags } from '../features/sharedMembership/types';

export const useCenterFeatureFlags = () => {
    const authObject = getItemWithExpiration('authObject');
    const authorization = getItemWithExpiration('authorization');
    const centerId = authObject?.centerId || '';

    const query = useQuery({
        queryKey: ['centerFeatureFlags', centerId],
        queryFn: () => getCenterFeatureFlagsAPI(centerId, authorization),
        enabled: !!centerId && !!authorization,
        staleTime: 5 * 60 * 1000,
    });

    const sharedMembership = normalizeSharedMembershipFeatureFlags(
        query.data?.data?.features?.sharedMembership,
    );

    return {
        ...query,
        isNewOpportunityEnabled: query.data?.data?.features?.newOpportunity === true,
        sharedMembership,
        isSharedMembershipReadEnabled: sharedMembership.read,
        isSharedMembershipCreatePoolEnabled: sharedMembership.createPool,
        isSharedMembershipMutateParticipantsEnabled: sharedMembership.mutateParticipants,
        isSharedMembershipStaffBookingEnabled: sharedMembership.staffBooking,
    };
};
